module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Orders","noOrders":"No orders."},"es":{"title":"Pedidos","noOrders":"Sin ordenes."},"sw":{"title":"Mahitaji","noOrders":"Hakuna maagizo."}}')
  delete Component.options._Ctor
}
